import ButtonInput from './input';

export default ButtonInput;
